<template>
    <li @click="onClickHotSearch">{{ item }}</li>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: ["item"],
    methods: {
        onClickHotSearch(){
            this.$emit("onClickHotSearch");
        }
    },
};
</script>

<style lang="less">
</style>
